import product from './product'
import errCode from './error-code'
import baseConst from './base-const'
import * as order from './order'
import * as regExp from './reg-exp'

export default { product, errCode, baseConst, order, regExp }
